import { type UpdateUserApi } from '@api/user/types';
import { camelToSnake } from '@helpers/camelCaseConverter';
import { removeUndefined } from '@helpers/object';

import { type UpdateUser } from './types';

/**
 * Model to transform user data from API
 */
export const updateUserModel = ({
  id,
  firstName,
  lastName,
  email,
  account,
  initials,
  isActive,
  isAssigned,
  isMspAccount,
  role,
}: UpdateUser): UpdateUserApi =>
  removeUndefined({
    id,
    first_name: firstName,
    last_name: lastName,
    email,
    account,
    initials,
    is_active: isActive,
    is_assigned: isAssigned,
    is_vatglobal: isMspAccount,
    role: role ? camelToSnake(role) : undefined,
  });
